exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kvalue{\n    color: rebeccapurple;\n    font-weight: 500;\n}\n\n.rating{\n    /* position: relative;\n    margin: auto 34px; */\n    display: flex;\n    justify-content: center;\n}", ""]);

